export interface PlatformAdminAccessInput {
  platformAccessVerified?: boolean;
  isSuperAdmin?: boolean;
  isPlatformAdmin?: boolean;
  platformAdminAreas?: string[];
  isAdmin?: boolean;
  isLegacyAdmin?: boolean;
  legacyFallbackEnabled: boolean;
  requiredArea?: string;
}

export function canAccessPlatformAdmin({
  platformAccessVerified,
  isSuperAdmin,
  isPlatformAdmin,
  platformAdminAreas = [],
  isAdmin,
  requiredArea,
  isLegacyAdmin,
  legacyFallbackEnabled,
}: PlatformAdminAccessInput): boolean {
  if (!platformAccessVerified) return false;
  const legacyAccess = legacyFallbackEnabled && isAdmin && isLegacyAdmin;
  const areaAllowed = !requiredArea
    || isSuperAdmin
    || legacyAccess
    || platformAdminAreas.includes('*')
    || platformAdminAreas.includes(requiredArea);
  return Boolean((isSuperAdmin || isPlatformAdmin || legacyAccess) && areaAllowed);
}
